'use client';

import * as React from 'react';

import { cn } from '../../lib/cn';

export interface RadioOptionCardProps {
	/** Nome del gruppo radio (attributo `name` nativo, raggruppa le opzioni mutuamente esclusive). */
	name: string;
	/** Valore di questa opzione. */
	value: string;
	/** Se true, l'opzione è selezionata. */
	checked: boolean;
	/** Chiamata alla selezione di questa opzione. */
	onSelect: () => void;
	/** Titolo dell'opzione. */
	title: React.ReactNode;
	/** Descrizione sotto il titolo. */
	description?: React.ReactNode;
}

/** Opzione selezionabile bordata, con radio button, titolo e descrizione. */
const RadioOptionCard = ({
	name,
	value,
	checked,
	onSelect,
	title,
	description,
}: RadioOptionCardProps) => (
	<label
		className={cn(
			'flex cursor-pointer gap-3 rounded-lg border p-3 transition-colors',
			checked ? 'border-accent bg-accent/5' : 'border-border bg-background hover:border-accent/40',
		)}
	>
		<input
			type="radio"
			name={name}
			value={value}
			checked={checked}
			onChange={onSelect}
			className="mt-0.5 accent-[hsl(var(--accent))]"
		/>
		<div>
			<p className="text-[13px] font-semibold">{title}</p>
			{description && <p className="text-[12px] text-text-muted">{description}</p>}
		</div>
	</label>
);
RadioOptionCard.displayName = 'RadioOptionCard';

export { RadioOptionCard };
